/*!
 * vuModes.js — how a sound wants to be metered: vu:stereo / vu:mono on its line
 * © 2026 Rob Canning — GPLv3
 *
 *     synth(uid:s3, ..., pan:-0.5, vu:stereo)   a pair of bars wherever it is metered
 *     audio(uid:rain, src:rain, vu:mono)         one bar, even in vu(all, stereo)
 *
 * Set by the sound's cue (synth.js, audioFile.js), read by vu.js. Its own
 * module: vu.js imports audioFile.js, which must not import vu.js back.
 */

const modes = new Map();          // sound name -> "stereo" | "mono"

/** The sound's line said vu:stereo or vu:mono (anything else: no wish). */
export function setVuMode(key, mode) {
  const name = String(key ?? "").split("__")[0];
  const m = String(mode ?? "").toLowerCase();
  if (!name) return;
  if (m === "stereo" || m === "mono") modes.set(name, m);
  else modes.delete(name);
}

/** "stereo", "mono", or undefined when its line said nothing. */
export const vuModeOf = name => modes.get(String(name));
